import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px 16px 20px;
  display: flex;
  background-color: #182231;
  justify-content: space-between;
`;

export default Container;
